import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { GetDisneyPlusWebToken } from '../configs/entity.config';
import { Observable } from 'rxjs';
import { DisneyPlusWebTokenResource } from '@dch/products-business-logic';

@Injectable({
  providedIn: 'root',
})
export class DisneyPlusAccountManagementService {
  constructor() {}

  getDisneyPlusToken(
    payload: any,
  ): Observable<IEntity<DisneyPlusWebTokenResource>> {
    return EntityManager.getEntity(GetDisneyPlusWebToken, {
      serviceId: payload.serviceId,
      token: payload.token,
    });
  }
}
